import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import { WindowDropDowns } from 'components';
import dropDownData from './dropDownData';
import ie from 'assets/windowsIcons/ie-paper.png';
import earth from 'assets/windowsIcons/earth.png';
import windows from 'assets/windowsIcons/windows.png';
import back from 'assets/windowsIcons/back.png';
import forward from 'assets/windowsIcons/forward.png';
import stop from 'assets/windowsIcons/stop.png';
import refresh from 'assets/windowsIcons/refresh.png';
import home from 'assets/windowsIcons/home.png';
import search from 'assets/windowsIcons/299(32x32).png';
import favorite from 'assets/windowsIcons/744(32x32).png';
import history from 'assets/windowsIcons/history.png';
import mail from 'assets/windowsIcons/mail.png';
import printer from 'assets/windowsIcons/17(32x32).png';
import edit from 'assets/windowsIcons/edit.png';
import msn from 'assets/windowsIcons/msn.png';
import go from 'assets/windowsIcons/290.png';
import links from 'assets/windowsIcons/links.png';
import dropdown from 'assets/windowsIcons/dropdown.png';

// ── Google 2010 Homepage ──
function GoogleHome({ onSearch }) {
  const [q, setQ] = useState('');
  return (
    <GooglePage>
      <div className="g-nav-top">
        <div className="g-nav-left">
          <span className="g-nav-link active">Web</span>
          <span className="g-nav-link">Images</span>
          <span className="g-nav-link">Videos</span>
          <span className="g-nav-link">Maps</span>
          <span className="g-nav-link">News</span>
          <span className="g-nav-link">Shopping</span>
          <span className="g-nav-link">Mail</span>
          <span className="g-nav-more">more ▼</span>
        </div>
        <div className="g-nav-right">
          <span className="g-nav-link">iGoogle</span>
          <span className="g-nav-link">Search settings</span>
          <span className="g-nav-link">Sign in</span>
        </div>
      </div>
      <div className="g-body">
        <div className="g-logo">
          <span className="g-logo-G" style={{color:'#3366cc'}}>G</span>
          <span className="g-logo-o" style={{color:'#cc0000'}}>o</span>
          <span className="g-logo-o2" style={{color:'#f4a020'}}>o</span>
          <span className="g-logo-g" style={{color:'#3366cc'}}>g</span>
          <span className="g-logo-l" style={{color:'#009933'}}>l</span>
          <span className="g-logo-e" style={{color:'#cc0000'}}>e</span>
          <span className="g-logo-tm">™</span>
        </div>
        <div className="g-search-wrap">
          <input
            className="g-search-input"
            value={q}
            onChange={e => setQ(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && q && onSearch(q)}
            autoFocus
          />
          <div className="g-search-links">
            <span className="g-nav-link">Advanced Search</span><br />
            <span className="g-nav-link">Language Tools</span>
          </div>
        </div>
        <div className="g-btn-row">
          <button className="g-btn" onClick={() => q && onSearch(q)}>Google Search</button>
          <button className="g-btn" onClick={() => q && onSearch(q)}>I'm Feeling Lucky</button>
        </div>
        <div className="g-radio-row">
          Search:&nbsp;
          <label><input type="radio" defaultChecked /> the web</label>
          &nbsp;&nbsp;
          <label><input type="radio" /> pages from your country</label>
        </div>
      </div>
      <div className="g-footer">
        <div className="g-footer-links">
          <span className="g-nav-link">Advertising Programmes</span>
          &nbsp;-&nbsp;
          <span className="g-nav-link">Business Solutions</span>
          &nbsp;-&nbsp;
          <span className="g-nav-link">About Google</span>
        </div>
        <div className="g-footer-copy">©2010 - <span className="g-nav-link">Privacy</span></div>
      </div>
    </GooglePage>
  );
}

// ── Search Results Page ──
function SearchResults({ query, onBack }) {
  const results = [
    {
      title: `${query} - Wikipedia, the free encyclopedia`,
      url: `en.wikipedia.org/wiki/${query.replace(/ /g,'_')}`,
      desc: `${query} refers to many things depending on context. This article covers the most common usage, history, and related topics as documented by Wikipedia contributors.`,
    },
    {
      title: `${query} | Definition & Meaning - Merriam-Webster`,
      url: `www.merriam-webster.com/dictionary/${query.toLowerCase()}`,
      desc: `The definition of ${query.toLowerCase()} according to Merriam-Webster. Full definition, synonyms, etymology, and example sentences.`,
    },
    {
      title: `Everything you need to know about ${query}`,
      url: `www.about.com/${query.toLowerCase().replace(/ /g,'-')}`,
      desc: `A complete guide to ${query}. Learn about the basics, advanced techniques, and best practices from industry experts.`,
    },
    {
      title: `${query} - YouTube`,
      url: `www.youtube.com/results?search_query=${query.replace(/ /g,'+')}`,
      desc: `Videos about ${query}. Watch tutorials, reviews, and more on YouTube.`,
    },
    {
      title: `${query} - Yahoo! Answers`,
      url: `answers.yahoo.com/search/search_result?p=${query.replace(/ /g,'+')}`,
      desc: `Community answers to questions about ${query}. Join the discussion and share your knowledge.`,
    },
  ];

  return (
    <ResultsPage>
      <div className="r-top">
        <div className="r-logo-small">
          <span style={{color:'#3366cc'}}>G</span>
          <span style={{color:'#cc0000'}}>o</span>
          <span style={{color:'#f4a020'}}>o</span>
          <span style={{color:'#3366cc'}}>g</span>
          <span style={{color:'#009933'}}>l</span>
          <span style={{color:'#cc0000'}}>e</span>
        </div>
        <input className="r-search-input" defaultValue={query} />
        <button className="r-search-btn">Search</button>
      </div>
      <div className="r-tabs">
        <span className="r-tab active">Web</span>
        <span className="r-tab">Images</span>
        <span className="r-tab">Maps</span>
        <span className="r-tab">News</span>
        <span className="r-tab">Shopping</span>
        <span className="r-tab">more ▼</span>
      </div>
      <div className="r-body">
        <div className="r-meta">Results 1 - 10 of about 142,000,000 for <b>{query}</b> (0.24 seconds)</div>
        {results.map((r, i) => (
          <div key={i} className="r-result">
            <div className="r-title">{r.title}</div>
            <div className="r-url">{r.url}</div>
            <div className="r-desc">{r.desc}</div>
          </div>
        ))}
      </div>
    </ResultsPage>
  );
}

function InternetExplorer({ onClose }) {
  const [route, setRoute] = useState('home');
  const [query, setQuery] = useState('');
  const [addressVal, setAddressVal] = useState('google.com');
  const inputRef = useRef(null);

  function onSearch(q) {
    setQuery(q);
    setRoute('results');
    setAddressVal(`google.com/search?q=${encodeURIComponent(q)}`);
  }
  function goHome() {
    setRoute('home');
    setAddressVal('google.com');
    setQuery('');
  }
  function onClickOptionItem(item) {
    if (item === 'Close') onClose();
    if (item === 'Home Page' || item === 'Back') goHome();
  }

  return (
    <Div>
      {/* Menu bar */}
      <section className="ie__toolbar">
        <div className="ie__options">
          <WindowDropDowns items={dropDownData} onClickItem={onClickOptionItem} height={21} />
        </div>
        <img className="ie__windows-logo" src={windows} alt="windows" />
      </section>

      {/* Nav buttons — IE7 style */}
      <section className="ie__function_bar">
        <div onClick={route !== 'home' ? goHome : undefined}
          className={`ie__function_bar__button${route === 'home' ? '--disable' : ''}`}>
          <img className="ie__function_bar__icon" src={back} alt="back" />
          <span className="ie__function_bar__text">Back</span>
          <div className="ie__function_bar__arrow" />
        </div>
        <div className="ie__function_bar__button--disable">
          <img className="ie__function_bar__icon" src={forward} alt="forward" />
          <div className="ie__function_bar__arrow" />
        </div>
        <div className="ie__function_bar__button">
          <img className="ie__function_bar__icon--margin-1" src={stop} alt="stop" />
        </div>
        <div className="ie__function_bar__button">
          <img className="ie__function_bar__icon--margin-1" src={refresh} alt="refresh" />
        </div>
        <div className="ie__function_bar__button" onClick={goHome}>
          <img className="ie__function_bar__icon--margin-1" src={home} alt="home" />
        </div>
        <div className="ie__function_bar__separate" />
        <div className="ie__function_bar__button">
          <img className="ie__function_bar__icon--normalize" src={search} alt="search" />
          <span className="ie__function_bar__text">Search</span>
        </div>
        <div className="ie__function_bar__button">
          <img className="ie__function_bar__icon--normalize" src={favorite} alt="favorites" />
          <span className="ie__function_bar__text">Favorites</span>
        </div>
        <div className="ie__function_bar__button">
          <img className="ie__function_bar__icon" src={history} alt="history" />
        </div>
        <div className="ie__function_bar__separate" />
        <div className="ie__function_bar__button">
          <img className="ie__function_bar__icon--margin-1" src={mail} alt="mail" />
          <div className="ie__function_bar__arrow--margin-11" />
        </div>
        <div className="ie__function_bar__button">
          <img className="ie__function_bar__icon--margin12" src={printer} alt="print" />
        </div>
        <div className="ie__function_bar__button--disable">
          <img className="ie__function_bar__icon" src={edit} alt="edit" />
        </div>
        <div className="ie__function_bar__button">
          <img className="ie__function_bar__icon--margin12" src={msn} alt="msn" />
        </div>
      </section>

      {/* Address bar */}
      <section className="ie__address_bar">
        <div className="ie__address_bar__title">Address</div>
        <div className="ie__address_bar__content">
          <img src={ie} alt="ie" className="ie__address_bar__content__img" />
          <input
            ref={inputRef}
            className="ie__address_bar__content__input"
            value={addressVal}
            onChange={e => setAddressVal(e.target.value)}
            onKeyDown={e => {
              if (e.key === 'Enter') {
                const v = addressVal.toLowerCase();
                if (v.includes('google') || v === '') goHome();
                else onSearch(addressVal);
              }
            }}
          />
          <img src={dropdown} alt="dropdown" className="ie__address_bar__content__img" />
        </div>
        <div className="ie__address_bar__go" onClick={() => {
          if (addressVal.toLowerCase().includes('google') || !addressVal) goHome();
          else onSearch(addressVal);
        }}>
          <img className="ie__address_bar__go__img" src={go} alt="go" />
          <span className="ie__address_bar__go__text">Go</span>
        </div>
        <div className="ie__address_bar__separate" />
        <div className="ie__address_bar__links">
          <span className="ie__address_bar__links__text">Links</span>
          <img className="ie__address_bar__links__img" src={links} alt="links" />
        </div>
      </section>

      {/* Content */}
      <div className="ie__content">
        <div className="ie__content__inner">
          {route === 'home'    && <GoogleHome onSearch={onSearch} />}
          {route === 'results' && <SearchResults query={query} onBack={goHome} />}
        </div>
      </div>

      {/* Status bar */}
      <footer className="ie__footer">
        <div className="ie__footer__status">
          <img className="ie__footer__status__img" src={ie} alt="" />
          <span className="ie__footer__status__text">Done</span>
        </div>
        <div className="ie__footer__block" />
        <div className="ie__footer__block" />
        <div className="ie__footer__block" />
        <div className="ie__footer__block" />
        <div className="ie__footer__right">
          <img className="ie__footer__right__img" src={earth} alt="" />
          <span className="ie__footer__right__text">Internet</span>
          <div className="ie__footer__right__dots" />
        </div>
      </footer>
    </Div>
  );
}

const GooglePage = styled.div`
  font-family: Arial, sans-serif;
  font-size: 13px;
  background: #fff;
  min-height: 100%;
  display: flex;
  flex-direction: column;

  .g-nav-top {
    display: flex;
    justify-content: space-between;
    padding: 4px 8px 0;
    border-bottom: 1px solid #e0e0e0;
    font-size: 11px;
  }
  .g-nav-left, .g-nav-right { display: flex; gap: 12px; align-items: center; }
  .g-nav-link {
    color: #00c; text-decoration: none; cursor: pointer;
    &:hover { text-decoration: underline; }
    &.active { color: #000; font-weight: bold; border-bottom: 2px solid #00c; padding-bottom: 2px; }
  }
  .g-nav-more { color: #00c; cursor: pointer; font-size: 11px; }

  .g-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 60px;
    gap: 16px;
  }
  .g-logo {
    font-size: 72px;
    font-weight: bold;
    line-height: 1;
    letter-spacing: -2px;
    font-family: 'Times New Roman', serif;
  }
  .g-logo-tm { font-size: 16px; vertical-align: super; color: #999; }

  .g-search-wrap {
    display: flex;
    align-items: flex-start;
    gap: 12px;
  }
  .g-search-input {
    width: 400px;
    height: 26px;
    border: 1px solid #999;
    border-top-color: #ccc;
    border-radius: 1px;
    padding: 0 6px;
    font-size: 15px;
    outline: none;
    box-shadow: inset 0 1px 2px rgba(0,0,0,0.1);
    &:focus { border-color: #4d90fe; box-shadow: 0 0 0 1px #4d90fe; }
  }
  .g-search-links { font-size: 11px; line-height: 1.8; }

  .g-btn-row { display: flex; gap: 8px; }
  .g-btn {
    padding: 4px 12px;
    background: linear-gradient(to bottom, #f5f5f5, #e8e8e8);
    border: 1px solid #d0d0d0;
    border-radius: 2px;
    font-size: 12px;
    cursor: pointer;
    color: #333;
    &:hover { background: linear-gradient(to bottom, #f8f8f8, #ebebeb); border-color: #aaa; box-shadow: 0 1px 2px rgba(0,0,0,0.15); }
    &:active { background: #e8e8e8; }
  }
  .g-radio-row { font-size: 12px; color: #333; }

  .g-footer {
    text-align: center;
    padding: 16px;
    font-size: 11px;
    color: #666;
    border-top: 1px solid #e0e0e0;
  }
  .g-footer-links { margin-bottom: 4px; }
  .g-footer-copy { }
`;

const ResultsPage = styled.div`
  font-family: Arial, sans-serif;
  font-size: 13px;
  background: #fff;
  min-height: 100%;

  .r-top {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 12px;
    border-bottom: 1px solid #e0e0e0;
  }
  .r-logo-small {
    font-size: 26px;
    font-weight: bold;
    font-family: 'Times New Roman', serif;
    letter-spacing: -1px;
    flex-shrink: 0;
    cursor: pointer;
  }
  .r-search-input {
    flex: 1;
    max-width: 400px;
    height: 24px;
    border: 1px solid #999;
    border-radius: 1px;
    padding: 0 6px;
    font-size: 13px;
    outline: none;
    &:focus { border-color: #4d90fe; }
  }
  .r-search-btn {
    padding: 3px 10px;
    background: linear-gradient(to bottom, #f5f5f5, #e8e8e8);
    border: 1px solid #ccc;
    font-size: 12px;
    cursor: pointer;
    &:hover { border-color: #aaa; }
  }

  .r-tabs {
    display: flex;
    gap: 0;
    padding: 4px 12px 0;
    border-bottom: 1px solid #e0e0e0;
    font-size: 12px;
  }
  .r-tab {
    padding: 4px 12px;
    cursor: pointer;
    color: #00c;
    border-bottom: 2px solid transparent;
    &:hover { text-decoration: underline; }
    &.active { color: #000; border-bottom-color: #dd4b39; font-weight: bold; }
  }

  .r-body { padding: 12px 16px; }
  .r-meta { font-size: 11px; color: #666; margin-bottom: 16px; }

  .r-result {
    margin-bottom: 20px;
  }
  .r-title {
    font-size: 14px;
    color: #00c;
    cursor: pointer;
    &:hover { text-decoration: underline; }
  }
  .r-url {
    font-size: 11px;
    color: #093;
    margin: 1px 0;
  }
  .r-desc {
    font-size: 12px;
    color: #444;
    line-height: 1.5;
    max-width: 580px;
  }
`;

const Div = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  background: linear-gradient(to right, #edede5 0%, #ede8cd 100%);

  .ie__toolbar {
    position: relative;
    display: flex;
    align-items: center;
    height: 24px;
    border-bottom: 1px solid rgba(255,255,255,0.7);
    flex-shrink: 0;
  }
  .ie__options {
    height: 23px;
    border-bottom: 1px solid rgba(0,0,0,0.15);
    border-right: 1px solid rgba(0,0,0,0.15);
    padding-left: 2px;
    flex: 1;
  }
  .ie__windows-logo {
    height: 100%;
    border-left: 1px solid white;
    border-bottom: 1px solid rgba(0,0,0,0.1);
  }
  .ie__function_bar {
    height: 36px;
    display: flex;
    align-items: center;
    font-size: 11px;
    padding: 1px 3px 0;
    border-bottom: 1px solid rgba(0,0,0,0.1);
  }
  .ie__function_bar__button {
    display: flex; height: 100%; align-items: center;
    border: 1px solid transparent; border-radius: 3px; cursor: pointer;
    &:hover { border-color: rgba(0,0,0,0.1); box-shadow: inset 0 -1px 1px rgba(0,0,0,0.1); }
    &:active > * { transform: translate(1px,1px); }
  }
  .ie__function_bar__button--disable {
    filter: grayscale(1); opacity: 0.7;
    display: flex; height: 100%; align-items: center;
    border: 1px solid transparent;
  }
  .ie__function_bar__text { margin-right: 4px; font-size: 11px; }
  .ie__function_bar__icon { height: 30px; width: 30px; }
  .ie__function_bar__icon--normalize { height: 22px; width: 22px; margin: 0 4px 0 1px; }
  .ie__function_bar__icon--margin12 { height: 22px; width: 22px; margin: 0 1px 0 2px; }
  .ie__function_bar__icon--margin-1 { margin: 0 -1px; height: 30px; width: 30px; }
  .ie__function_bar__separate { height: 90%; width: 1px; background: rgba(0,0,0,0.2); margin: 0 2px; }
  .ie__function_bar__arrow {
    height: 100%; display: flex; align-items: center; margin: 0 4px;
    &:before { content:''; display:block; border-width:3px 3px 0; border-color:#000 transparent; border-style:solid; }
  }
  .ie__function_bar__arrow--margin-11 {
    height: 100%; display: flex; align-items: center; margin: 0 1px 0 -1px;
    &:before { content:''; display:block; border-width:3px 3px 0; border-color:#000 transparent; border-style:solid; }
  }

  .ie__address_bar {
    border-top: 1px solid rgba(255,255,255,0.7);
    height: 22px;
    font-size: 11px;
    display: flex;
    align-items: center;
    padding: 0 2px 2px;
    box-shadow: inset 0 -2px 3px -1px #2d2d2d;
    flex-shrink: 0;
  }
  .ie__address_bar__title { color: rgba(0,0,0,0.5); padding: 5px; }
  .ie__address_bar__content {
    border: rgba(122,122,255,0.6) 1px solid;
    height: 100%; display: flex; flex: 1; align-items: center;
    background: white; position: relative;
    &__img { width: 14px; height: 14px; }
    &__img:last-child { width: 15px; height: 15px; right: 1px; position: absolute; }
    &__input {
      position: absolute; left: 16px; right: 17px;
      border: none; outline: none;
      font-size: 11px; font-family: Tahoma, sans-serif;
      background: transparent;
    }
  }
  .ie__address_bar__go {
    display: flex; align-items: center;
    padding: 0 18px 0 5px; height: 100%; position: relative; cursor: pointer;
    &__img { height: 95%; border: 1px solid rgba(255,255,255,0.2); margin-right: 3px; }
  }
  .ie__address_bar__separate { height: 100%; width: 1px; background: rgba(0,0,0,0.1); box-shadow: 1px 0 rgba(255,255,255,0.7); }
  .ie__address_bar__links {
    display: flex; align-items: center; padding: 0 18px 0 5px; height: 100%; position: relative;
    &__img { position: absolute; right: 2px; top: 3px; height: 5px; width: 8px; }
    &__text { color: rgba(0,0,0,0.5); }
  }

  .ie__content {
    flex: 1; overflow: auto; padding-left: 1px;
    border-left: 1px solid #6f6f6f;
    background: #fff; position: relative;
  }
  .ie__content__inner { min-height: 100%; width: 100%; }

  .ie__footer {
    height: 20px;
    border-top: 1px solid transparent;
    box-shadow: inset 0 1px 3px rgba(50,50,50,0.8);
    background: rgb(236,233,216);
    display: flex; align-items: center; padding-top: 2px;
    flex-shrink: 0;
  }
  .ie__footer__status {
    flex: 1; height: 100%; display: flex; align-items: center; padding-left: 2px;
    &__text { font-size: 11px; }
    &__img { height: 14px; width: 14px; margin-right: 3px; }
  }
  .ie__footer__block { height: 85%; width: 22px; border-left: 1px solid rgba(0,0,0,0.15); box-shadow: inset 1px 0 rgba(255,255,255,0.7); }
  .ie__footer__right {
    display: flex; align-items: center; width: 150px; height: 80%;
    border-left: 1px solid rgba(0,0,0,0.11); box-shadow: inset 1px 0 rgba(255,255,255,0.7);
    padding-left: 5px; position: relative;
    &__text { font-size: 11px; }
    &__img { height: 14px; width: 14px; margin-right: 3px; }
    &__dots {
      position: absolute; right: 11px; bottom: -1px; width: 2px; height: 2px;
      box-shadow: 2px 0 rgba(0,0,0,0.25), 5.5px 0 rgba(0,0,0,0.25), 9px 0 rgba(0,0,0,0.25),
        5.5px -3.5px rgba(0,0,0,0.25), 9px -3.5px rgba(0,0,0,0.25), 9px -7px rgba(0,0,0,0.25);
    }
  }
`;

export default InternetExplorer;
